interface Config {
  onSuccess?(registration: ServiceWorkerRegistration): void;
  onUpdate?(registration: ServiceWorkerRegistration): void;
  onInstalled?(): void;
}

function registerValidSW(swUrl: string, config?: Config) {
  navigator.serviceWorker
    .register(swUrl)
    .then(registration => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === "installed") {
            if (navigator.serviceWorker.controller) {
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }

              if (config && config.onInstalled) {
                config.onInstalled();
              }
            }
          }
        };
      };

      if (registration.active) {
        if (config && config.onInstalled) {
          config.onInstalled();
        }
      }

      if (registration.waiting) {
        if (config && config.onSuccess) {
          config.onSuccess(registration);
        }
      }

      // fix for bug (onstatechange reload page)
      if (registration.installing) {
        const checkRegistration = setInterval(() => {
          navigator.serviceWorker
            .getRegistration()
            .then(
              (checkedRegistration: ServiceWorkerRegistration | undefined) => {
                if (checkedRegistration?.active) {
                  clearInterval(checkRegistration);

                  if (config && config.onInstalled) {
                    config.onInstalled();
                  }
                }
              }
            );
        }, 2000);
      }
    })
    .catch(error => {
      // eslint-disable-next-line
      console.error("Error during service worker registration:", error);
    });
}

export function register(config?: Config): void {
  if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    registerValidSW(`${process.env.PUBLIC_URL}/service-worker.js`, config);
  }
}

export function unregister(reload = true) {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then(registration => {
        registration.unregister();
        if (reload) {
          window.location.reload();
        }
      })
      .catch(() => {});
  }
}
